import React, { ReactNode, useState } from 'react';

import { ScrollView } from '@rbilabs/universal-components';
import { useWindowDimensions } from 'react-native';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

import { ActionsheetContentStyled } from './styled';

export const ModalAuthActionSheetContent: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const { height: windowHeight } = useWindowDimensions();
  const [scrollViewHeight, setScrollViewHeight] = useState<number | undefined>(undefined);

  const handleScrollViewLayout = (event: any) => {
    if (!scrollViewHeight) {
      const { height } = event.nativeEvent.layout;
      const twentyPercentOfWindowHeight = (windowHeight * 20) / 100;
      const finalHeight =
        height >= windowHeight ? windowHeight - twentyPercentOfWindowHeight : height;
      setScrollViewHeight(finalHeight);
    }
  };

  return (
    <ActionsheetContentStyled>
      <ScrollView
        onLayout={handleScrollViewLayout}
        maxHeight={scrollViewHeight}
        contentContainerStyle={{ height: '100%' }}
      >
        <KeyboardAwareScrollView showsVerticalScrollIndicator>{children}</KeyboardAwareScrollView>
      </ScrollView>
    </ActionsheetContentStyled>
  );
};
